const ChevronLeft = (props: React.ComponentProps<'svg'>) => {
  const { fill = '#8C98AB', ...rest } = props;

  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_3212_68255)">
        <path
          d="M22.5875 30.576C21.8042 31.3594 21.8042 32.626 22.5875 33.401L38.5875 49.4094C39.3708 50.1927 40.6375 50.1927 41.4125 49.4094C42.1875 48.626 42.1958 47.3594 41.4125 46.5844L26.8292 31.9927L41.4208 17.4094C42.2042 16.626 42.2042 15.3594 41.4208 14.5844C40.6375 13.8094 39.3708 13.801 38.5958 14.5844L22.5875 30.576Z"
          fill={fill}
        />
        ``
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.1233 14.114C39.1639 13.0638 40.8517 13.0834 41.8897 14.1104C42.9382 15.1477 42.9345 16.8384 41.8922 17.8807L27.772 31.9929L41.8814 46.1104C41.8809 46.1099 41.8819 46.1109 41.8814 46.1104C42.9315 47.151 42.9133 48.8402 41.8864 49.8782C40.8491 50.9266 39.1584 50.923 38.1161 49.8807L22.1186 33.8749C22.1182 33.8744 22.1191 33.8753 22.1186 33.8749C21.0716 32.8375 21.0743 31.1464 22.1161 30.1046L38.1233 14.114C38.1238 14.1136 38.1228 14.1145 38.1233 14.114ZM40.952 15.0582C40.4237 14.5356 39.5793 14.5382 39.0697 15.0532L39.067 15.056L23.0589 31.0474C22.5348 31.5718 22.5382 32.4144 23.0564 32.927L23.059 32.9297L39.0589 48.9379C39.0589 48.9379 39.0589 48.9379 39.0589 48.9379C39.5833 49.4622 40.4259 49.4586 40.9386 48.9404C41.4612 48.4122 41.4586 47.5678 40.9436 47.0582L40.941 47.0556L25.8864 31.9924L40.9494 16.9379C40.9494 16.9379 40.9495 16.9379 40.9494 16.9379C41.4737 16.4135 41.4701 15.5709 40.952 15.0582Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3212_68255">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChevronLeft;
